<template>
  <div id="post-share">
    <div class="post-share-wrapper" v-if="networks.length > 0">
      <ShareNetwork
        v-for="network in networks"
        :network="network.network"
        :key="network.network"
        :style="{ backgroundColor: network.color }"
        :url="network.url"
        :title="network.title"
        :description="network.description"
        :quote="network.quote"
        :hashtags="network.hashtags"
        class="m-r-10"
      >
        <i :class="network.icon" />
        <span>{{ network.name }}</span>
      </ShareNetwork>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal_share_post",
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      networks: [],
      content: this.data["content"],
    };
  },
  created: function () {
    let network = [
      {
        name: "WhatsApp",
        network: "whatsapp",
        color: "",
        icon: "bi bi-whatsapp m-r-5",
        url: window.location.origin,
        title: this.content,
      },
      {
        name: "Telegram",
        network: "telegram",
        color: "",
        icon: "bi bi-telegram m-r-5",
        url: window.location.origin,
        title: this.content,
      },
    ];
    this.networks = network;
  },
};
</script>